import { FC } from 'react';
import { CourseLessons } from '@new/features/courses/components/CourseLessons/CourseLessons';
import { useVideoCallContext } from 'src/contexts/VideoCallProvider';

export const ObjectivesPanel: FC = () => {
  const { courseId } = useVideoCallContext();

  if (!courseId) {
    return (
      <div className="flex items-center justify-center h-64 p-4">
        <p className="text-(--neutral-black-NB800)! [font-size:var(--fs-l3)]!">
          No course available
        </p>
      </div>
    );
  }

  return (
    <div className="p-4">
      <CourseLessons
        courseId={courseId}
        titleClassName="[font-size:var(--fs-h6)]! text-(--neutral-black-NB800)!"
      />
    </div>
  );
};
